import { render, staticRenderFns } from "./PartFaultyModal.vue?vue&type=template&id=a5d84b9c&scoped=true"
import script from "./PartFaultyModal.vue?vue&type=script&lang=js"
export * from "./PartFaultyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d84b9c",
  null
  
)

export default component.exports